import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudySparkle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCloudySparkle"><Path d="M12.4 14H11.6L10.6 16.6L8 17.6V18.4L10.6 19.4L11.6 22H12.4L13.4 19.4L16 18.4V17.6L13.4 16.6L12.4 14Z" fill="currentColor"/><Path d="M9 4C11.9981 4 14.6088 5.64932 15.9785 8.08691C16.3108 8.02987 16.6524 8 17 8C20.3137 8 23 10.6863 23 14C23 16.9729 20.8376 19.4382 18 19.9141V16.2266L14.9473 15.0518L13.7734 12H10.2266L9.05176 15.0518L6 16.2266V19.416C3.06862 18.229 1 15.357 1 12C1 7.58172 4.58172 4 9 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloudySparkle;
